//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        userTagList: [],
        ignoreUserTagList: [],
        dateFrom: '',
        dateTo: '',
      },
    };
  },

  computed: {
    ...mapState('statisticsReferralProgram', ['filterLists']),
    ...mapState('users', ['userTagsList']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('statisticsReferralProgram', ['setFilters']),
  },
};
